export function dropFAPrefix(icon: string | undefined) {
	if (icon && icon.startsWith('fa-')) return icon.substring(3)
	return icon
}